import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'bookings/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('bookings/', '')
      .toLowerCase();
  }
}
